import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "product",
        headerName: "Product",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },

];

export const MaterialInPopup = (props) => {
    return (
        <ModalBasic
            id="material-in"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Material in details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Sr. no</label>
                        <TextInput type='text'
                            id='srNo' name='srNo'
                            value={props.materialObject.srNo}
                            handleChange={(event) => props.handleChange(event, 'srNo')}
                            className={props.validState?.error?.srNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.materialObject.date}
                            handleChange={(event) => props.handleChange(event, 'date')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select material out</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.materialObject.materialList}
                            value={props.materialObject.idMaterialOut ? props.materialObject.materialList.find(x => x.value === props.materialObject.idMaterialOut) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idMaterialOut")
                            }
                            className={props.validState?.error?.idMaterialOut !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Gate pass</label>
                        <TextInput type='number'
                            id='gatepass' name='gatepass'
                            value={props.materialObject.gatepass}
                            handleChange={(event) => props.handleChange(event, 'gatepass')}
                            className={props.validState?.error?.gatepass !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Invoice no</label>
                        <TextInput type='number'
                            id='invoiceNo' name='invoiceNo'
                            value={props.materialObject.invoiceNo}
                            handleChange={(event) => props.handleChange(event, 'invoiceNo')}
                            className={props.validState?.error?.invoiceNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Invoice date</label>
                        <TextInput type='date'
                            id='invDate' name='invDate'
                            value={props.materialObject.invDate}
                            handleChange={(event) => props.handleChange(event, 'invDate')}
                            className={props.validState?.error?.invDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Supplier</label>
                        <MultiSelectDropdown
                            drpIdentity="Select supplier"
                            options={props.materialObject.supplierList}
                            value={props.materialObject.idSupplier ? props.materialObject.supplierList.find(x => x.value === props.materialObject.idSupplier) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idSupplier")
                            }
                            className={props.validState?.error?.idSupplier !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Inward by</label>
                        <MultiSelectDropdown
                            drpIdentity="Select inward"
                            options={props.materialObject.inwardList}
                            value={props.materialObject.idInward ? props.materialObject.supplierInward.find(x => x.value === props.materialObject.idInward) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idInward")
                            }
                            className={props.validState?.error?.idInward !== undefined ? "error" : ""}
                        />

                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Material details</span>
                <div className="process-table h-[30vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.materialObject.itemList}
                            columnDefs={props.materialObject.itemListColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}